import { docReady } from '../helpers/docReady';
import '../../styles/templates/product.scss';
import '../snippets/modal';
import '../snippets/enquiry-form';
docReady(() => {
    // console.log('Product Template');
});
